import React, { useState } from "react";
import styled from "styled-components";

import ShadowBox from "../core/ShadowBox";
import useViewStore from "../../store/useViewStore";

const BlueBox = ({ children, ...props }) => {
  const { isMobileView } = useViewStore();

  return (
    <BXBlueBox $isMobileView={isMobileView} {...props}>
      {children}
    </BXBlueBox>
  );
};

const BXBlueBox = styled(ShadowBox)`
  flex-direction: column;
  padding: 24px 64px;
  ${(props) => props.$isMobileView ? `padding: 24px 16px;` : `padding: 24px 64px;`}
  background-color: var(--aia-bx-blue-5);
`;

export default BlueBox;